<template>
  <NuxtLink to="/" class="header-logo">
    <Img
      src="/images/question/title/normal.svg?v=3"
      alt="NHK出版ぷれぜんつ 英語クイズ 〜街ナカ英会話編"
      :width="264"
      :height="70"
    />
  </NuxtLink>
</template>

<script setup lang="ts"></script>

<style scoped>
.header-logo {
  @apply block pt-4;
}
</style>
